import { Teacher } from '../../../types/Teacher';
import { TeacherInfo } from '../../../types/TeacherInfo';

type TeacherType = Teacher | TeacherInfo;

function generateRandomRate() {
  // Average between 3.5 and 5.0 with one decimal precision
  const average = Math.round((3.5 + Math.random() * 1.5) * 10) / 10;
  // Quantity between 5 and 120
  const quantity = Math.floor(Math.random() * 116) + 5;

  return { average, quantity };
}

export function teacherAdapter<T extends TeacherType>(teacher: T): T {
  const isStaging = process.env.REACT_APP_ESTUDI_API_URL?.includes('staging');

  return {
    ...teacher,
    last_name: teacher.last_name[0] + '.',
    rate: isStaging ? generateRandomRate() : teacher.rate
  };
}
